import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { PricingSelector } from './PricingSelector';
import { UrgencyBanner } from './UrgencyBanner';
export const Pricing = () => {
  return <section id="pricing" className="py-16 md:py-24 bg-cream-100 relative border-y border-gold-500/20" data-id="element-221">
      <div className="container mx-auto px-4 md:px-6" data-id="element-222">
        <SectionHeading title="ELEGÍ TU ACCESO A 'LA MEMORIA DEL ALMA'" subtitle="Ambas opciones incluyen entrega digital inmediata y acceso de por vida." data-id="element-223" />

        <UrgencyBanner variant="light" data-id="element-224" />

        <PricingSelector variant="light" data-id="element-225" />
      </div>
    </section>;
};